let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5j4Hn")).then(() => parcelRequire('cw0UK'));